import React, { useContext, useState } from "react";
import { LeadData } from "./VayuLead";
import CardDiv from "modules/common/card-div/CardDiv";
import { Col, Row } from "react-bootstrap";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { useVayuLead } from "./store";
import CallCut from "assets/svgs/call_cut.js";
import CallIcon from "assets/svgs/table_call";

function VayuHeader() {
  const { doc } = useContext(LeadData);
  const { setToaster } = useToast();
  const { vayuLeadCall } = useVayuLead();
  const [callIcon, setCallIcon] = useState(<CallIcon />);

  return (
    <div>
      <div
        style={{
          top: "1rem",
          position: "sticky",
          zIndex: "99",
        }}
        className="d-flex flex-column justify-content-between bg-white border-primary mx-3 mb-3 ms-0 mt-1 rounded"
      >
        <CardDiv
          component={
            <>
              <div className="w-100 d-flex justify-content-between ps-3">
                <div className="flex-1">
                  <Row
                    style={{ width: "100%", position: "sticky", top: "0" }}
                    className="d-flex flex-wrap gap-2"
                  >
                    <Col
                      className="pe-0 text-black"
                      style={{ flex: 3.8, cursor: "pointer" }}
                    >
                      <div className="d-flex flex-column">
                        <div className="d-flex flex-row flex-wrap gap-1 w-100">
                          <div
                            className="d-flx flex-column shadow-sm  p-2"
                            style={{ width: "45%" }}
                          >
                            <div
                              className="fs-1 text-truncate"
                              style={{ color: "#333333", fontSize: "1rem" }}
                            >
                              Name
                            </div>
                            <div className="fw-bold text-black text-truncate">
                              {doc?.user?.[0]?.first_name}
                            </div>
                          </div>
                          <div
                            className="d-flx flex-column shadow-sm  p-2"
                            style={{ width: "45%" }}
                          >
                            <div
                              className="fs-1 text-truncate"
                              style={{ color: "#333333", fontSize: "1rem" }}
                            >
                              Gender
                            </div>
                            <div className="fw-bold text-black">
                              {doc?.user?.[0]?.gender?.toUpperCase() === "F"
                                ? "Female"
                                : doc?.user?.[0]?.gender?.toUpperCase() === "M"
                                ? "Male"
                                : "N/A"}
                            </div>
                          </div>
                        </div>
                        <div className="d-flex flex-row flex-wrap w-100 gap-1">
                          <div
                            className="d-flx flex-column shadow-sm  p-2 mt-1"
                            style={{ width: "45%" }}
                          >
                            <div
                              className="fs-1"
                              style={{ color: "#333333", fontSize: "1rem" }}
                            >
                              Email
                            </div>
                            <div className="fw-bold text-truncate text-black">
                              {doc?.user?.[0]?.email}
                            </div>
                          </div>
                          <div
                            className="d-flx flex-column shadow-sm  p-2 mt-1"
                            style={{ width: "45%" }}
                          >
                            <div
                              className="text-truncate"
                              style={{ color: "#333333", fontSize: "1rem" }}
                            >
                              Phone Number
                            </div>
                            <div className="fw-bold text-black text-truncate">
                              {doc?.user?.[0]?.primary_phone_number}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col>
                      <div className="d-flex align-items-end">
                        <Row className="py-2 w-0">
                          <div className="d-flex flex-column gap-2 justify-content-center">
                            <div className={`text-center ${"cursor-pointer"}`}>
                              <span
                                className={`text-center ${"cursor-pointer"}`}
                                onClick={() => {
                                  setCallIcon(<CallCut />);
                                  vayuLeadCall(
                                    {
                                      user_id: doc?.user_id,
                                      phone_number:
                                        (doc?.user?.[0]?.primary_phone_number_country_code +
                                        doc?.user[0]?.primary_phone_number),
                                    },
                                    setToaster
                                  );
                                }}
                              >
                                {callIcon}
                              </span>
                            </div>
                          </div>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </>
          }
        />
      </div>
    </div>
  );
}

export default VayuHeader;
